import React, { useState } from 'react';
import axios from 'axios'; // Import axios
import { Accordion, AccordionTab } from 'primereact/accordion';

// Style
import './subtitleTranslation.css'; 

// Components
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { set } from 'date-fns';


const SubtitleTranslation = () => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [originalLanguage, setOriginalLanguage] = useState('en'); 
    const [targetLanguage, setTargetLanguage] = useState('pt'); 
    const [loading, setLoading] = useState(false);

    const languages = [
        { name: 'English', code: 'en' },
        { name: 'Portuguese', code: 'pt' },
        { name: 'Spanish', code: 'es' },
        { name: 'French', code: 'fr' },
        { name: 'German', code: 'de' },
        { name: 'Italian', code: 'it' },
        { name: 'Japanese', code: 'ja' },
        { name: 'Korean', code: 'ko' },
        { name: 'Chinese', code: 'zh' },
        { name: 'Russian', code: 'ru' },
        { name: 'Dutch', code: 'nl' },
        { name: 'Swedish', code: 'sv' },
        { name: 'Polish', code: 'pl' },
        { name: 'Turkish', code: 'tr' },
        { name: 'Arabic', code: 'ar' },
        { name: 'Hindi', code: 'hi' },
        { name: 'Vietnamese', code: 'vi' },
        { name: 'Thai', code: 'th' },
        { name: 'Indonesian', code: 'id' }
    ];


    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setSelectedFile(file);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);

        if (selectedFile) {
            try {
                const formData = new FormData();
                formData.append('file', selectedFile);
                formData.append('targetLanguage', targetLanguage.code);
                formData.append('originalLanguage', originalLanguage.code);

                const response = await axios.post(
                    process.env.REACT_APP_TRANSLATE, // API endpoint from .env file
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                        responseType: 'blob' // Important: Tell axios to expect a Blob
                    }
                );

                // Create a download link and trigger the download
                const downloadUrl = window.URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', selectedFile.name); // Use original filename
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            } catch (error) {
                console.error('Error:', error);
                // Consider adding user-friendly error handling, e.g., using a Toast component
            }

            setLoading(false);
        }
    };

    return (
        <div className="grid">
            <div className="col-12">
                <Accordion activeIndex={-1}>
                    <AccordionTab header="Instructions">
                        <p>Upload a subtitle file (e.g., .srt, .vtt) and select the original and target languages for translation.</p>
                    </AccordionTab>
                </Accordion>

                <br />

                <div className="container">
                    <div className="field-territory">
                        <label htmlFor="originalLanguage">Original Language:</label>
                        <Dropdown
                            id="originalLanguage"
                            style={{ width: '175px' }}
                            value={originalLanguage}
                            onChange={(e) => setOriginalLanguage(e.value)}
                            options={languages}
                            optionLabel="name"
                            placeholder="Select language"
                        />
                    </div>

                    <div className="field-territory">
                        <label htmlFor="targetLanguage">Target Language:</label>
                        <Dropdown
                            id="targetLanguage"
                            style={{ width: '175px' }}
                            value={targetLanguage}
                            onChange={(e) => setTargetLanguage(e.value)}
                            options={languages}
                            optionLabel="name"
                            placeholder="Select language"
                        />
                    </div>
                </div>

                <br />

                <form onSubmit={handleSubmit}>
                    <input
                        type="file"
                        id="fileInputSubtitle"
                        placeholder="Choose subtitle file"
                        onChange={handleFileChange}
                        accept=".srt, .vtt" 
                    />
                    <br />
                    <br />
                    <Button
                        type="submit"
                        label="Process and Download"
                        icon="pi pi-download"
                        className="p-button-info mr-2"
                    />
                    {loading && <p>Loading...</p>}
                </form>
            </div>
        </div>
    );
};

export default SubtitleTranslation;